import { useState } from 'react';
import {
  aplicarPreferenciaTema,
  lerPreferenciaTema,
  type PreferenciaTema,
} from '../lib/preferenciaTema';
import css from './BotaoTema.module.css';
import { Icone, type NomeIcone } from './Icone';

const PROXIMA: Record<PreferenciaTema, PreferenciaTema> = {
  sistema: 'claro',
  claro: 'escuro',
  escuro: 'sistema',
};
const ICONE: Record<PreferenciaTema, NomeIcone> = {
  sistema: 'automatico',
  claro: 'sol',
  escuro: 'lua',
};
const NOME: Record<PreferenciaTema, string> = {
  sistema: 'automático (segue o sistema)',
  claro: 'claro',
  escuro: 'escuro',
};

/** Alterna Automático → Claro → Escuro, como nos apps. A escolha fica neste navegador. */
export function BotaoTema() {
  const [preferencia, setPreferencia] = useState(lerPreferenciaTema);
  return (
    <button
      type="button"
      className={css.botao}
      aria-label={`Tema ${NOME[preferencia]}. Mudar para ${NOME[PROXIMA[preferencia]]}`}
      title={`Tema ${NOME[preferencia]}`}
      onClick={() => {
        const proxima = PROXIMA[preferencia];
        aplicarPreferenciaTema(proxima);
        setPreferencia(proxima);
      }}
    >
      <Icone nome={ICONE[preferencia]} />
    </button>
  );
}
